import { useEffect } from "react";

/**
 * While a Drawer or Modal is open the page carries `data-overlay-open` on <body>, so the floating chat button (bottom-right) can step aside
 * instead of sitting on top of the dialog's own buttons. A counter keeps it set while several are stacked.
 */
let openCount = 0;

export function useOverlayFlag(open: boolean) {
  useEffect(() => {
    if (!open) return;
    openCount += 1;
    document.body.setAttribute("data-overlay-open", "");
    return () => {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) document.body.removeAttribute("data-overlay-open");
    };
  }, [open]);
}
